import { connect } from 'react-redux';

import { STYLING_VALUE_BACKGROUND_POSITION_FILL } from 'sharedParts';

import stylingSelector from '../selectors';
import { getActiveEditorSection, isFullWidthSurvey } from '../../../reducers';
import mapEditorSectionToUrl from '../../../config/mapEditorSectionToUrl';

const {
  getStylingPageBackgroundColor,
  getStylingBodyBackgroundColor,
  getStylingBodyBackgroundImageUrl,
  getStylingBodyBackgroundPosition,
} = stylingSelector;

const mapStateToProps = state => {
  let backgroundColor = getStylingBodyBackgroundColor(state);
  const imageUrl = getStylingBodyBackgroundImageUrl(state);
  let backgroundImage = imageUrl && `url(${imageUrl})`;

  if (isFullWidthSurvey(state)) {
    backgroundColor = getStylingPageBackgroundColor(state);
    backgroundImage = null;
  }

  const backgroundSize = {
    [STYLING_VALUE_BACKGROUND_POSITION_FILL]: 'contain',
  }[getStylingBodyBackgroundPosition(state)];

  let isBodyStylingApplied = true;
  const activeEditorSection = getActiveEditorSection(state);
  if (activeEditorSection) {
    isBodyStylingApplied = [
      mapEditorSectionToUrl.globalStyling,
      mapEditorSectionToUrl.preview,
      mapEditorSectionToUrl.landing,
      mapEditorSectionToUrl.survey,
      mapEditorSectionToUrl.ty,
    ].includes(activeEditorSection);
  }

  return {
    styleBody: isBodyStylingApplied
      ? {
          backgroundColor,
          backgroundImage,
          backgroundPosition: '50% 0',
          backgroundSize,
        }
      : {},
  };
};

export default connect(mapStateToProps);
